import { render, staticRenderFns } from "./MtBasicList.vue?vue&type=template&id=18a5beee&scoped=true&"
import script from "./MtBasicList.vue?vue&type=script&lang=js&"
export * from "./MtBasicList.vue?vue&type=script&lang=js&"
import style0 from "./MtBasicList.vue?vue&type=style&index=0&id=18a5beee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a5beee",
  null
  
)

export default component.exports